/**
 * File Mutations Module - Barrel Exports
 *
 * Central export point for all file mutation hooks and utilities
 */

// Constants
export { MAX_FILE_SIZE, ALLOWED_FILE_TYPES } from './constants';

// Helper functions
export { createFileErrorHandler, validateFile, shouldRetry } from './helpers';

// Delete operations
export { useDeleteFile } from './delete-mutations';

// Update operations
export {
  useUpdateFile,
  useUncategoriseFile,
  useCategoriseFile,
  useAssignIdentityDocument
} from './update-mutations';

// Upload operations
export { useUploadFile } from './upload-mutations';
